(function(){
'use strict';

scFacebookPixelService.$inject = ["$log", "$window", "scAnalyticsServiceSettings"];
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Service for initializing Facebook Pixel on the client-side after member data is loaded.
 *
 * This service replaces the server-side Facebook pixel initialization that was previously
 * done in xp.index.html. It ensures that the pixel is initialized with member data
 * after it's loaded from the /me endpoint.
 *
 * @param $log
 * @param $window
 * @param scAnalyticsServiceSettings
 */
function scFacebookPixelService($log, $window, scAnalyticsServiceSettings) {
  'use strict';

  var _this = this;

  var isInitialized = false;
  var isScriptLoaded = false;

  /**
   * Load the Facebook pixel script if not already loaded
   */
  var loadFacebookPixelScript = function loadFacebookPixelScript() {
    if (isScriptLoaded || $window.fbq) {
      return Promise.resolve();
    }
    return new Promise(function (resolve) {
      // Facebook pixel script loader
      // eslint-disable-next-line func-names
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        // eslint-disable-next-line no-multi-assign, no-param-reassign
        n = f.fbq = function () {
          var _n;

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          // eslint-disable-next-line no-unused-expressions
          n.callMethod ? (_n = n).callMethod.apply(_n, args) : n.queue.push(args);
        };
        // eslint-disable-next-line no-param-reassign
        if (!f._fbq) f._fbq = n;
        // eslint-disable-next-line no-param-reassign
        n.push = n;
        // eslint-disable-next-line no-param-reassign
        n.loaded = true;
        // eslint-disable-next-line no-param-reassign
        n.version = '2.0';
        // eslint-disable-next-line no-param-reassign
        n.queue = [];
        // eslint-disable-next-line no-param-reassign
        t = b.createElement(e);
        // eslint-disable-next-line no-param-reassign
        t.async = true;
        // eslint-disable-next-line no-param-reassign
        t.src = v;
        // eslint-disable-next-line no-param-reassign
        t.onload = function () {
          isScriptLoaded = true;
          resolve();
        };
        // eslint-disable-next-line no-param-reassign
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })($window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    });
  };

  /**
   * Get the pixel ID from analytics service settings
   * Prioritizes campaign pixel over organization pixel
   */
  var getPixelId = function getPixelId() {
    var campaignPixel = scAnalyticsServiceSettings.getByName('campaign', 'facebook_pixel');
    var orgPixel = scAnalyticsServiceSettings.getByName('organization', 'facebook_pixel');

    return campaignPixel && campaignPixel.parameters && campaignPixel.parameters.pixel_id || orgPixel && orgPixel.parameters && orgPixel.parameters.pixel_id || null;
  };

  /**
   * Initialize Facebook pixel with member data
   * @param {Object} memberData - Member data from /me endpoint
   */
  var initializePixel = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var memberData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var pixelId, initData;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!isInitialized) {
                _context.next = 3;
                break;
              }

              $log.debug('[scFacebookPixelService] Already initialized');
              return _context.abrupt('return');

            case 3:
              pixelId = getPixelId();

              if (pixelId) {
                _context.next = 7;
                break;
              }

              $log.debug('[scFacebookPixelService] No pixel ID found');
              return _context.abrupt('return');

            case 7:
              _context.prev = 7;
              _context.next = 10;
              return loadFacebookPixelScript();

            case 10:

              // Initialize the pixel with member data
              initData = {};

              if (memberData.email_address) {
                initData.em = memberData.email_address;
              }
              if (memberData.first_name) {
                initData.fn = memberData.first_name;
              }
              if (memberData.last_name) {
                initData.ln = memberData.last_name;
              }
              $window.fbq('init', pixelId, initData);
              $window.fbq('track', 'PageView');

              isInitialized = true;
              _context.next = 22;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context['catch'](7);

              $log.error('[scFacebookPixelService] Failed to initialize:', _context.t0);

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[7, 19]]);
    }));

    return function initializePixel() {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   * Initialize Facebook pixel with a delay to allow browser to focus on first-render
   * @param {Object} memberData - Member data from /me endpoint
   */
  var initializeWithDelay = function initializeWithDelay() {
    var memberData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // Delay pixel loading so that we can let the browser focus on first-render stuff
    setTimeout(function () {
      initializePixel(memberData);
    }, 10);
  };

  var isPixelInitialized = function isPixelInitialized() {
    return isInitialized;
  };

  return {
    initializeWithDelay: initializeWithDelay,
    initializePixel: initializePixel,
    getPixelId: getPixelId,
    isPixelInitialized: isPixelInitialized,
    loadFacebookPixelScript: loadFacebookPixelScript
  };
}

angular.module('classy').service('scFacebookPixelService', scFacebookPixelService);
})();